<div class="chrono-wrapper">
  <!-- ── Toolbar ──────────────────────────────────────────────────────────── -->
  <div class="chrono-toolbar">
    <button class="btn-add" (click)="openAddModal()">
      + Aggiungi Esperienza
    </button>
  </div>

  <!-- ── Empty state ──────────────────────────────────────────────────────── -->
  <p *ngIf="timeline.length === 0" class="chrono-empty">
    Nessuna esperienza ancora. Clicca il pulsante "Aggiungi Esperienza" per
    iniziare
  </p>

  <!-- ══════════════════════════════════════════════════════════════════════
       TIMELINE
  ══════════════════════════════════════════════════════════════════════ -->
  <div class="timeline">
    <div
      *ngFor="
        let entry of timeline;
        trackBy: trackByIndex;
        let last = last;
        let i = index
      "
      class="timeline-item"
      [class.timeline-item--last]="last"
    >
      <!-- Rail -->
      <div class="timeline-rail">
        <div class="timeline-dot"></div>
        <div class="timeline-line" *ngIf="!last"></div>
      </div>

      <!-- Card -->
      <div class="timeline-card">
        <!-- Header: dates + action buttons -->
        <div class="timeline-card__header">
          <div class="timeline-dates">
            <span class="badge badge-date">{{
              formatMonth(entry.startMonth)
            }}</span>
            <span class="timeline-arrow">→</span>
            <span
              class="badge"
              [class.badge-ongoing]="!entry.endMonth"
              [class.badge-date]="!!entry.endMonth"
            >
              {{ formatMonth(entry.endMonth) }}
            </span>
          </div>
          <div class="timeline-actions">
            <button
              class="timeline-actions__btn timeline-actions__btn--edit"
              (click)="openEditModal(entry, i)"
              title="Modifica esperienza"
            >
              <svg
                width="15"
                height="15"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
              >
                <path
                  d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"
                />
                <path
                  d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"
                />
              </svg>
            </button>
            <button
              class="timeline-actions__btn timeline-actions__btn--delete"
              (click)="onDelete(entry, i)"
              title="Elimina esperienza"
            >
              <svg
                width="15"
                height="15"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
              >
                <polyline points="3 6 5 6 21 6" />
                <path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6" />
                <path d="M10 11v6M14 11v6" />
                <path d="M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2" />
              </svg>
            </button>
          </div>
        </div>

        <!-- Title row -->
        <div class="timeline-meta">
          <span class="timeline-employer">{{ entry.employer }}</span>
          <span class="badge badge-cluster" *ngIf="entry.ageRangeLabel">{{
            entry.ageRangeLabel
          }}</span>
          <span *ngIf="entry.age" class="timeline-years">
            {{ entry.age }} {{ entry.age === 1 ? "anno" : "anni" }} exp.
          </span>
        </div>

        <!-- Tasks -->
        <ul *ngIf="entry.tasks.length > 0" class="timeline-tasks">
          <li *ngFor="let t of entry.tasks">{{ taskLabel(t) }}</li>
        </ul>

        <!-- Extra tasks -->
        <div *ngIf="entry.extraTasks.length > 0" class="timeline-extras">
          <span class="extras-label">Altro:</span>
          <span *ngFor="let et of entry.extraTasks; let last = last">
            {{ et }}<span *ngIf="!last">, </span>
          </span>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- ══════════════════════════════════════════════════════════════════════════
     ADD / EDIT MODAL
══════════════════════════════════════════════════════════════════════════ -->
<div *ngIf="showModal" class="modal-backdrop" (click)="closeModal()">
  <div
    class="modal-panel"
    (click)="$event.stopPropagation()"
    [formGroup]="form"
  >
    <!-- Header -->
    <div class="modal-header">
      <h3 class="modal-title">
        {{ editMode ? "Modifica Esperienza" : "Aggiungi Esperienza" }}
      </h3>
      <button class="modal-close" (click)="closeModal()">
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    </div>

    <!-- Body -->
    <div class="modal-body">
      <!-- Age / cluster (babysitter + petsitter only) -->
      <div class="field" *ngIf="showAgeSelect">
        <label class="field__label">
          {{ type === "babysitter" ? "Età bambino*" : "Età animale*" }}
        </label>
        <select
          class="field__select"
          formControlName="clusterNumber"
          [attr.disabled]="editMode ? true : null"
        >
          <option value="">Seleziona</option>
          <option *ngFor="let opt of ageOptions; let i = index" [value]="i + 1">
            {{ opt }}
          </option>
        </select>
      </div>

      <!-- Employer -->
      <div class="field">
        <label class="field__label">Presso*</label>
        <select class="field__select" formControlName="employer">
          <option value="">Seleziona</option>
          <option *ngFor="let opt of employerOptions" [value]="opt">
            {{ opt }}
          </option>
        </select>
      </div>

      <!-- Currently working -->
      <div class="field field--inline">
        <input
          type="checkbox"
          id="currently"
          formControlName="currentlyWorking"
          class="field__checkbox"
        />
        <label for="currently" class="field__label field__label--inline">
          Sto lavorando ancora qui
        </label>
      </div>

      <!-- Start date -->
      <div class="field">
        <label class="field__label">Data Inizio*</label>
        <div class="field__row">
          <select class="field__select" formControlName="startMonth">
            <option value="">Mese</option>
            <option *ngFor="let m of months; let i = index" [value]="i + 1">
              {{ m }}
            </option>
          </select>
          <input
            class="field__input"
            type="number"
            formControlName="startYear"
            placeholder="Anno"
            [min]="1950"
            [max]="currentYear"
          />
        </div>
      </div>

      <!-- End date -->
      <div class="field" *ngIf="!isCurrently">
        <label class="field__label">Data Fine*</label>
        <div class="field__row">
          <select class="field__select" formControlName="endMonth">
            <option value="">Mese</option>
            <option *ngFor="let m of months; let i = index" [value]="i + 1">
              {{ m }}
            </option>
          </select>
          <input
            class="field__input"
            type="number"
            formControlName="endYear"
            placeholder="Anno"
            [min]="1950"
            [max]="currentYear"
          />
        </div>
      </div>

      <!-- Date error -->
      <p class="field__error" *ngIf="dateError">⚠️ {{ dateError }}</p>

      <!-- Tasks -->
      <div class="field" *ngIf="availableTasks.length > 0">
        <label class="field__label">Attività*</label>
        <div class="tasks-grid" formGroupName="tasks">
          <label *ngFor="let t of availableTasks" class="task-item">
            <input
              type="checkbox"
              [formControlName]="t"
              class="task-item__check"
            />
            <span class="task-item__label">{{ taskLabel(t) }}</span>
          </label>
        </div>
      </div>

      <!-- Extra activities -->
      <div
        class="field"
        *ngIf="
          availableTasks.includes('other') && tasksGroup.get('other')?.value
        "
      >
        <label class="field__label">Attività extra</label>
        <div class="extra-list">
          <div
            *ngFor="let ctrl of extraActivities.controls; let i = index"
            class="extra-item"
          >
            <input
              class="field__input"
              type="text"
              [formControl]="extraCtrl(i)"
              [placeholder]="'Descrivi l\'attività ' + (i + 1)"
            />
            <button
              type="button"
              class="extra-item__remove"
              (click)="removeExtra(i)"
            >
              <svg
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
              >
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>
          </div>
        </div>
        <button
          type="button"
          class="btn-add-extra"
          (click)="addExtra()"
          [disabled]="extraActivities.length >= maxExtra"
        >
          + Aggiungi altra attività
        </button>
      </div>
    </div>

    <!-- Footer -->
    <div class="modal-footer">
      <button class="btn-cancel" (click)="closeModal()">Annulla</button>
      <button
        class="btn-save"
        (click)="onSubmit()"
        [disabled]="form.invalid || !!dateError"
      >
        {{ editMode ? "Aggiorna" : "Aggiungi" }}
      </button>
    </div>
  </div>
</div>
